import ApiClient from "../api-client.js";

export const SERVICE_NAME = "branches";
const adminClient = new ApiClient({ servicePath: `admin/${SERVICE_NAME}` });

export const getBranches = async ({ tenantId }) => {
  return await adminClient.get({
    path: `?tenantId=${tenantId}`,
  });
};
